import { Component } from "@angular/core";
import { DevextremesharedmoduleModule } from "../../../../../shared/Module/devextremeshared/devextremeshared.module";
import { UIUtils } from "../../../../../services/uiutils.service";
import { AppStateManageService } from "../../../../../services/app-state-manage.service";
import { ScreenSizeService } from "../../../../../services/screensize.service";
import notify from "devextreme/ui/notify";
import { Zone } from "../../../../../classes/domain/entities/website/masters/zone/zone";
import { District } from "../../../../../classes/domain/entities/website/masters/district/district";
import { Block } from "../../../../../classes/domain/entities/website/masters/block/block";
import { PHC } from "../../../../../classes/domain/entities/website/masters/phc/phc";
import { AFPostMaster } from "../../../../../classes/domain/entities/website/masters/sanctioned-posts/af-post/afpost";
import { State } from "../../../../../classes/domain/entities/website/masters/state/state";
import { AshaEmployeeRecord } from "../../../../../classes/domain/entities/website/masters/asha/asha-employee-record/ashaemployeerecord";
import {
  DomainEnums,
  Month,
  OperationalModes,
} from "../../../../../classes/infrastructure/enums";
import { MonthYearInitService } from "../../../../../services/finantial-year-wise-months.service";
import { NavItem_Entity_Authority } from "../../../../../shared/components/side-navigation-menu/side-navigation-menu.component";
import { Router } from "@angular/router";
import { SidebarMenuStateService } from "../../../../../services/sidebarmenustateservice";
import { DxLoadPanelModule } from "devextreme-angular";
import { HealthDepartmentProfile } from "../../../../../classes/domain/entities/website/masters/landing-page/health-department-profile/healthdepartmentprofile";
import { BaseUrlService } from "../../../../../services/baseurl.service";
import { BreadcrumbService } from "../../../../../services/breadcrumb.service";
import { SUBMENU_ID } from "../../../../../classes/domain/constants";

@Component({
  selector: "app-health-department-profile-master",
  templateUrl: "./health-department-profile-master.component.html",
  styleUrl: "./health-department-profile-master.component.scss",
  standalone: true,
  imports: [DevextremesharedmoduleModule, DxLoadPanelModule],
})
export class HealthDepartmentProfileMasterComponent {
  dataSource: HealthDepartmentProfile[] = [];
  Entity: HealthDepartmentProfile = HealthDepartmentProfile.CreateNewInstance();
  isSaveDisabled: boolean = false;
  IsNewEntity: boolean = true;
  SelectedHealthDepartmentProfile: HealthDepartmentProfile =
    HealthDepartmentProfile.CreateNewInstance();
  MasterList: HealthDepartmentProfile[] = [];
  pageSize: number = 0;
  loading = true;
  StateList: State[] = [];
  ZoneList: Zone[] = [];
  DistrictList: District[] = [];
  BlockList: Block[] = [];
  PHCList: PHC[] = [];
  AFPostList: AFPostMaster[] = [];
  AshaList: AshaEmployeeRecord[] = [];

  FinancialYearRef: number = 0;
  Month: number = 0;
  StateRef: number = 0;
  ZoneRef: number = 0;
  DistrictRef: number = 0;
  BlockRef: number = 0;
  PHCRef: number = 0;
  AFPostRef: number = 0;
  AshaEmployeeRecordRef: number = 0;

  MonthList = DomainEnums.MonthList(true, "Select Month");
  YearsList: { Ref: number; Name: string }[] = [];
  isApril: boolean = false;

  currentMonth: number = 0;
  PreviousMonth: number = 0;
  CurrentFinancialYear: string = "";
  March = Month.March;
  April = Month.April;
  LoginRole: number = 0;
  EntityType: string = "Health_Department_Profile_Master";
  EntityAuthority: NavItem_Entity_Authority | undefined = undefined;
  OperationalModes = OperationalModes;
  ImageBaseUrl: string = "";
  TimeStamp = Date.now();
  LoginToken = " ";

  constructor(
    private uiUtils: UIUtils,
    private appStateManage: AppStateManageService,
    private screenSizeService: ScreenSizeService,
    private monthYearService: MonthYearInitService,
    private router: Router,
    private sidebarMenuState: SidebarMenuStateService,
    private baseUrl: BaseUrlService,
  ) { }

  async ngOnInit() {
    this.ImageBaseUrl = this.baseUrl.GenerateImageBaseUrl();
    this.LoginToken = this.appStateManage.getLoginToken();

    // const menuPermissions = sessionStorage.getItem("menuPermissions");
    // let SideBarMenuItemList = menuPermissions
    //   ? (JSON.parse(menuPermissions) as NavItem_Entity_Authority[])
    //   : [];
    // this.EntityAuthority = SideBarMenuItemList.find(
    //   (e) => e.MenuId == this.EntityType,
    // );

    this.EntityAuthority = this.sidebarMenuState.getEntityAuthority(this.EntityType);


    this.FormulateHealthDepartmentProfile();
    this.loading = true;
    this.loading = false;
    this.pageSize = this.screenSizeService.getPageSize("withDropdown", 2);
  }

  public async FormulateHealthDepartmentProfile(): Promise<void> {
    this.MasterList = [];

    let lst = await HealthDepartmentProfile.FetchEntireList(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    // Append ImageBlobUrl directly to each class instance
    lst.forEach((data) => {
      if (data.p.profile_pic_path) {
        data.p.image_blob_url =
          this.ImageBaseUrl + data.p.profile_pic_path + "/" + this.LoginToken;
      }
    });
    lst.sort((a, b) => Number(a.p.seniority_level) - Number(b.p.seniority_level));
    this.MasterList = lst;
    this.dataSource = [...lst]; // force grid to update
  }

  onEditClicked = async (e: any, mode: OperationalModes) => {
    this.SelectedHealthDepartmentProfile = e.row
      .data as HealthDepartmentProfile;

    let SelectItem = this.SelectedHealthDepartmentProfile.GetEditableVersion();
    sessionStorage.setItem("fromTable", "true");
    HealthDepartmentProfile.SetCurrentInstance(SelectItem);
    this.appStateManage.StorageKey.setItem("Editable", "Edit");
    await this.router.navigate([SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER_DETAILS], {
      state: { fromMaster: true, mode: mode },
    });
  };

  OnDeleteClicked = async (e: any) => {
    const selectedHealthDepartmentProfile = e.row
      .data as HealthDepartmentProfile;
    await this.uiUtils.askForConfirmation(
      "Delete",
      `This process is <b>IRREVERSIBLE</b>!<br/>Are you sure you want to DELETE Health Department Profile <b>${selectedHealthDepartmentProfile.p.name_en}</b>?`,
      async () => {
        await selectedHealthDepartmentProfile.DeleteInstance(async () => {
          notify(`Health Department Profile  ${selectedHealthDepartmentProfile.p.name_en} been deleted`, "success", 4000);
          this.FormulateHealthDepartmentProfile();
        });
      },
    );
  };

  onCellPrepared(e: any) {
    if (e.rowType === "data" && e.column.caption === "Sr. No") {
      const pageIndex = e.component.pageIndex();
      const pageSize = e.component.pageSize();
      e.cellElement.innerText = pageIndex * pageSize + e.rowIndex + 1;
    }
  }

  async AddHealthDepartmentProfile() {
    sessionStorage.setItem("fromTable", "true"); // This flag allows details page to open only once.
    await this.router.navigate([SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER_DETAILS], {
      state: { fromMaster: true, mode: OperationalModes.CanAdd },
    });
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes(SUBMENU_ID.HEALTH_DEPARTMENT_PROFILE_MASTER_DETAILS)) {
      return;
    }
  }
}
